import React from 'react';

// Camera aperture iris wipe. phase: 'closing' | 'opening' | null
const IrisTransition = ({ phase }) => {
  if (!phase) return null;
  return (
    <div className={`xp-iris xp-iris-${phase}`} aria-hidden="true" data-testid="xp-iris">
      <div className="xp-iris-hole"></div>
    </div>
  );
};

export default IrisTransition;
